// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fdVknIArxCwtFuxNritG{grid-template-columns:auto auto;gap:16px;padding-top:40px;display:grid}.ZOZ2iXIY4ZAc_xGeQNPr{background:var(--background-primary-inverted-primary);position:-webkit-sticky;position:sticky;bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `fdVknIArxCwtFuxNritG`,
	"stickyActions": `ZOZ2iXIY4ZAc_xGeQNPr`
};
export default ___CSS_LOADER_EXPORT___;
